import { AbsatzVorgabe } from '@/domain/controlling/entities';

export function calculateUmsatzZielminuten(
  planwert: number | undefined,
  produktivitaet: number | undefined,
) {
  if (planwert && produktivitaet) {
    const zielstunden = Math.round((planwert / produktivitaet) * 60);
    return zielstunden;
  }
  return undefined;
}

export function calculatAbsatzZielminuten(
  planwert: number | undefined,
  produktivitaet: number | undefined,
  absatzVorgabe: AbsatzVorgabe,
) {
  if (planwert && produktivitaet) {
    const produktivitaetInStueck =
      absatzVorgabe === AbsatzVorgabe.Stueck
        ? produktivitaet
        : Math.round(60 / produktivitaet);

    if (produktivitaetInStueck === 0) return 0;

    const zielstunden = Math.round((planwert / produktivitaetInStueck) * 60);
    return zielstunden;
  }
  return undefined;
}
